// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
var __webpack_exports__ = __webpack_require__.O(undefined, ["node_vendors-node_modules_object-assign_index_js-node_modules_promise_lib_es6-extensions_js-n-536574"], () => (__webpack_require__("./src/normalize.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
